// ACTIONS

export const FETCH_EXPIRED_MANUAL_FORMS = 'FETCH_EXPIRED_MANUAL_FORMS';
export const FETCH_EXPIRED_MANUAL_FORMS_SUCCESS = 'FETCH_EXPIRED_MANUAL_FORMS_SUCCESS';
export const FETCH_EXPIRED_MANUAL_FORMS_FAILED = 'FETCH_EXPIRED_MANUAL_FORMS_FAILED';

// INITIAL STATE
const initialState = {
  data: [],
  loading: false,
};

// STORE
function expiredManualForms(state = initialState, action) {
  const { data } = action;
  switch (action.type) {
    case FETCH_EXPIRED_MANUAL_FORMS:
      return {
        ...state,
        loading: true,
      };
    case FETCH_EXPIRED_MANUAL_FORMS_SUCCESS:
      return {
        ...state,
        data,
        loading: false,
      };
    case FETCH_EXPIRED_MANUAL_FORMS_FAILED:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
}

// ACTION CREATORS
export function fetchExpiredManualForms(showLoader = false, message) {
  return {type: FETCH_EXPIRED_MANUAL_FORMS, showGlobalLoader: showLoader, message}
}

export function fetchExpiredManualFormsSuccess(data) {
  return {type: FETCH_EXPIRED_MANUAL_FORMS_SUCCESS, data, hideGlobalLoader: true}
}

export function fetchExpiredManualFormsFailed() {
  return {type: FETCH_EXPIRED_MANUAL_FORMS_FAILED, hideGlobalLoader: true}
}

export default expiredManualForms;
